export const MAX_HEIGHT = 300;
export const MIN_HEIGHT = 0;
export const MIN_WEIGHT = 0;
export const MAX_WEIGHT = 300;
export const MIN_AGE = 0;
export const MAX_AGE = 120;
export const MAX_NOTES_LENGTH = 1000;
